import { Observable } from 'rxjs/Observable';
import { ApplicationTypeConstants } from './../../../../../services/warmup/warmup.service';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from './../../../../../services/warmup/application-type.model';
import { ResolvePepMatchComponent } from './../resolvepepmatch/resolve-pepmatch.component';
import { PepEntity, PepMatchRecord } from './../../pep-match.model';
import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ConstantsService } from 'app/services/constants-service';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

import { PoliticallyExposed } from 'app/shared/models/politically-exposed.model';

import { PoliticallyExposedService } from 'app/entities/monitoring/actual/politicallyexposed/politically-exposed.service';
import { PersonHeaderService } from 'app/person/header/person-header.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { Person } from 'app/shared/models/person.model';

@Component({
  selector: 'pep-match',
  templateUrl: './politically-exposed-match.component.html',
  styleUrls: ['./politically-exposed-match.component.css']
})

/**
 * Component to display the monitoring Politically Exposed data for the entity.
 */
export class PoliticallyExposedMatchComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;
  public personId: number;

  dialogRef: MdDialogRef<any>;
  politicallyExposedMatchData: PepMatchRecord[];
  politicallyExposedMatchDataLength: number;
  politicallyExposedPersonData = new Person();
  politicallyExposedMatchLoaded = false;
  matchResolutions: ApplicationValue[];
  falseMatchReasons: ApplicationValue[];

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private politicallyExposedMatchService: PoliticallyExposedService,
    private snackBarService: SnackBarService,
    private personHeaderService: PersonHeaderService,
    private entityMonitoringService: EntityMonitoringService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.ngOnChanges();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION));
    this.setUpFalseMatchReasons(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.FALSE_MATCH_REASONS));
    this.politicallyExposedMatchService.addPEPMatch.subscribe(event => {
      if (event === 'AddedPepMatch') {
        this.ngOnChanges();
      }
    });
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.matchResolutions = response.values;
        }
      );
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  setUpFalseMatchReasons(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.falseMatchReasons = response.values;
        }
      );
    } else {
      this.falseMatchReasons = dropDownValues;
    }
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      this.personId = this.entityIdDetails.personId;
      this.getPoliticallyExposedMatchDesc();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getPoliticallyExposedMatchDesc() {
    this.politicallyExposedMatchLoaded = false;
    this.politicallyExposedMatchData = new Array<PepMatchRecord>();
    this.personHeaderService.getPerson(this.personId)
      .subscribe(response => {
        response.arrResult.personBirthdayForPrint = this.entityMonitoringService.getDateForPrint(response.arrResult.birthday);
        this.politicallyExposedPersonData = response.arrResult;
      });
    this.politicallyExposedMatchService.getPoliticallyExposedInfoMatchDesc(this.id, this.entityIdDetails.entityType)
      .subscribe(response => {
        this.politicallyExposedMatchData = response;
        this.politicallyExposedMatchDataLength = response.suggestionList.length;
        this.politicallyExposedMatchLoaded = true;
      });
  }

  resolvePepPressMatch(pepMatchRecord: PepMatchRecord, relationEntityId: number) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(ResolvePepMatchComponent, config);
    this.dialogRef.componentInstance.pepMatchRecord = pepMatchRecord;
    this.dialogRef.componentInstance.relationEntityId = relationEntityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.getPoliticallyExposedMatchDesc();
      }
    });
  }

  getMatchStatus(matchId) {
    if (this.matchResolutions) {
      const match = this.matchResolutions.find(matchResolution => matchResolution.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'Probable';
  }

  getFalseMatchReason(matchId) {
    if (this.falseMatchReasons) {
      const match = this.falseMatchReasons.find(falseMatchReason => falseMatchReason.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'N/A';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/politicallyexposed/politicallyexposedmatch/politically-exposed-match.component.ts